<div class="modal-header"><h4 class="modal-title">{{ params.actionLabel }} Results</h4></div>
<div class="modal-body">
    @if (isReset) {
        <p class="text-success">
            <i class="fa fa-check-circle"></i>
            {{ resetMessage }}
        </p>
    } @else {
        @if (successCount > 0) {
            <p class="text-success">
                <i class="fa fa-check-circle"></i>
                {{ successCount }} {{ successCount === 1 ? 'payment' : 'payments' }} updated successfully.
            </p>
        }
        @if (failures.length > 0) {
            <p class="text-warning">
                <i class="fa fa-exclamation-triangle"></i>
                {{ failures.length }} {{ failures.length === 1 ? 'payment' : 'payments' }} could not be updated:
            </p>
        }
        @if (successCount === 0 && failures.length === 0) {
            <p class="text-muted">No payments were updated.</p>
        }
    }
    @if (failures.length > 0) {
        <ul class="list-unstyled" style="max-height: 250px; overflow-y: auto;">
            @for (failure of failures; track failure.paymentId) {
                <li><strong>Payment ID {{ failure.paymentId }}:</strong> {{ failure.reason }}</li>
            }
        </ul>
    }
</div>
<div class="modal-footer"><button type="button" class="btn btn-primary" (click)="close()">Close</button></div>
